import React  from "react";
import { useParams } from "react-router-dom";
import PurchaseOrderForm from "./components/PurchaseOrderForm";

const EditPurchaseOrder = () => {
	const { orderId } = useParams();

	return (
		<PurchaseOrderForm
			recordId={orderId}
			mode="edit"
		/>
	);
};

export default EditPurchaseOrder;